export const formatNumber = (value: number) => Intl.NumberFormat('en-GB').format(value);
